import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const SpecPagesTags = props => {
  if (!props.pageTags || props.pageTags.length === 0) {
    return null;
  }
  return (
    <small className="tags">
      <i className="fa fa-tags" />{' '}
      {props.pageTags
        .map(item => (
          <Link key={`SpecPagesTag${item.id}`} to={`/spec/tag/${item.seo_url}`}>
            {item.title}
          </Link>
        ))
        .reduce(
          (prev, curr) => (prev === null ? [curr] : [...prev, ', ', curr]),
          null
        )}
    </small>
  );
};

SpecPagesTags.propTypes = {
  // CONNECT STATES
  pageTags: PropTypes.arrayOf(PropTypes.shape).isRequired
};

export default SpecPagesTags;



// WEBPACK FOOTER //
// ./src/components/SpecialPages/Common/SpecPagesTags/SpecPagesTags.js